import { PrivacySection1 } from '@/components/legal/PrivacySection1';
import { PrivacySection2 } from '@/components/legal/PrivacySection2';
import { PrivacySection2b } from '@/components/legal/PrivacySection2b';
import { PrivacySection3 } from '@/components/legal/PrivacySection3';
import { PrivacySection4 } from '@/components/legal/PrivacySection4';

export const PrivacyPolicyContent = () => {
  return (
    <div className="space-y-8">
      <PrivacySection1 />
      <PrivacySection2 />
      <PrivacySection2b />
      <PrivacySection3 />
      <PrivacySection4 />
    </div>
  );
};
